import React from "react";

const EditDealPaymentDetails = ({ formik, isEditableByAccountant }) => {
  return (
    <div className="row mb-3">
      {/* Source of fund */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Source of Fund</label>
          <div className="input-group">
            <select
              name="paymentDetails.sourceOfFund"
              className="form-select"
              value={formik?.values?.paymentDetails?.sourceOfFund}
              onChange={(e) => {
                formik.setFieldValue(
                  "paymentDetails.sourceOfFund",
                  e.target.value
                );
              }}
              disabled={!isEditableByAccountant}
            >
              <option value="">-None-</option>
              <option value="Self Funded">Self Funded</option>
              <option value="Loan">Loan</option>
              <option value="Our Installment">Our Installment</option>
            </select>
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Total Payment Verified */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Total Payment Verified</label>
          <div className="input-group">
            <select
              name="paymentDetails.totalPaymentVerified"
              className="form-select"
              value={formik?.values?.paymentDetails?.totalPaymentVerified}
              onChange={(e) => {
                formik.setFieldValue(
                  "paymentDetails.totalPaymentVerified",
                  e.target.value
                );
              }}
              disabled={!isEditableByAccountant}
            >
              <option value="">-None-</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Part Approved">Part Approved</option>
              <option value="Rejected">Rejected</option>
            </select>
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Payment Received */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Payment Received</label>
          <div className="input-group">
            <select
              name="paymentDetails.paymentReceived"
              className="form-select"
              value={formik?.values?.paymentDetails?.paymentReceived}
              onChange={(e) => {
                formik.setFieldValue(
                  "paymentDetails.paymentReceived",
                  e.target.value
                );
              }}
              disabled={!isEditableByAccountant}
            >
              <option value="">-None-</option>
              <option value="Part Payment">Part Payment</option>
              <option value="Full Payment">Full Payment</option>
            </select>
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Invoice Number */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Invoice Number </label>
          <div className="input-group">
            <input
              type="text"
              name="paymentDetails.invoiceNumber"
              className="form-control"
              value={formik?.values?.paymentDetails?.invoiceNumber}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              disabled={!isEditableByAccountant}
            />
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
          {formik?.touched?.paymentDetails?.invoiceNumber &&
          formik?.errors?.paymentDetails?.invoiceNumber ? (
            <div className="text-danger">
              {formik?.errors?.paymentDetails?.invoiceNumber}
            </div>
          ) : null}
        </div>
      </div>

      {/* Payment Status Remark */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Payment Status Remark </label>
          <div className="input-group">
            <input
              type="text"
              name="paymentDetails.paymentStatusRemark"
              className="form-control"
              value={formik?.values?.paymentDetails?.paymentStatusRemark}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              disabled={!isEditableByAccountant}
            />
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
          {formik?.touched?.paymentDetails?.paymentStatusRemark &&
          formik?.errors?.paymentDetails?.paymentStatusRemark ? (
            <div className="text-danger">
              {formik?.errors?.paymentDetails?.paymentStatusRemark}
            </div>
          ) : null}
        </div>
      </div>

      {/* Payment Description */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Payment Description </label>
          <div className="input-group">
            <input
              type="text"
              name="paymentDetails.paymentDescription"
              className="form-control"
              value={formik?.values?.paymentDetails?.paymentDescription}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              disabled={!isEditableByAccountant}
            />
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
          {formik?.touched?.paymentDetails?.paymentDescription &&
          formik?.errors?.paymentDetails?.paymentDescription ? (
            <div className="text-danger">
              {formik?.errors?.paymentDetails?.paymentDescription}
            </div>
          ) : null}
        </div>
      </div>

      {/* Loan Amount */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Loan Amount </label>
          <div className="input-group">
            <input
              type="number"
              name="paymentDetails.loanAmount"
              className="form-control"
              value={formik?.values?.paymentDetails?.loanAmount}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              disabled={!isEditableByAccountant}
            />
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
          {formik?.touched?.paymentDetails?.loanAmount &&
          formik?.errors?.paymentDetails?.loanAmount ? (
            <div className="text-danger">
              {formik?.errors?.paymentDetails?.loanAmount}
            </div>
          ) : null}
        </div>
      </div>

      {/* Loan Status */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">Loan Status </label>
          <div className="input-group">
            <input
              type="text"
              name="paymentDetails.loanStatus"
              className="form-control"
              value={formik?.values?.paymentDetails?.loanStatus}
              onChange={formik?.handleChange}
              onBlur={formik?.handleBlur}
              disabled={!isEditableByAccountant}
            />
            <div className="input-group-text">
              {isEditableByAccountant ? (
                <i className="ti ti-pencil" />
              ) : (
                <i className="ti ti-lock" />
              )}
            </div>
          </div>
          {formik?.touched?.paymentDetails?.loanStatus &&
          formik?.errors?.paymentDetails?.loanStatus ? (
            <div className="text-danger">
              {formik?.errors?.paymentDetails?.loanStatus}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default EditDealPaymentDetails;
